module.exports = __webpack_public_path__ + "static/media/sc10.37a5bce8.svg";